import Snowfall from 'react-snowfall';
import holiday from './holiday-25.png';
function App() {
  return (
    <div className="app">
      <Snowfall
        color="white"
        style={{ background: '#ff0000' }}
        snowflakeCount={350}
      />
      <a
        href="https://calendar.google.com/calendar/u/0/r/eventedit/copy/NjljbXA4dWVxbzBzb2w1bTkya2NmaXRuOGQgc3BlbmNlckBhbHJpZ2h0LnN0dWRpbw/c3BlbmNlckBhbHJpZ2h0LnN0dWRpbw"
        target="_blank"
        rel="noreferrer noopener"
        className="inner"
      >
        <img src={holiday} alt="Alright Studio Holiday Party 2025" />
      </a>
    </div>
  );
}

export default App;
